module.exports = __webpack_public_path__ + "static/media/tombstone.00ba584b.svg";